import script from "./ClassesBlocks.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassesBlocks.vue?vue&type=script&setup=true&lang=js"

import "./ClassesBlocks.vue?vue&type=style&index=0&id=4acff60c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acff60c"]])

export default __exports__